// app/src/lib/billing/subscription.js — client wrapper for the workplace
// subscription API. Card data never touches this code — only the one-time Finix
// token. All routes are workplace-scoped (Crew bills per workplace).

import { api } from '../api.js';

/** GET /workplaces/{wid}/subscription → { status, tier, cycle, currentPeriodEnd, autoRenew, ... } */
export function getStatus(workplaceId) {
  return api(`/workplaces/${workplaceId}/subscription`, { workplaceId });
}

/**
 * GET /workplaces/{wid}/tax-rate → WA sales-tax rate for a billing address (preview).
 * Non-WA → { taxable:false, combinedRate:0 }. WA → { taxable:true, resolved, combinedRate, ... }.
 * @param {string} workplaceId
 * @param {{ state:string, street?:string, city?:string, zip?:string }} addr
 */
export function getTaxRate(workplaceId, { state, street, city, zip } = {}) {
  const qs = new URLSearchParams({ state: state || '', street: street || '', city: city || '', zip: zip || '' }).toString();
  return api(`/workplaces/${workplaceId}/tax-rate?${qs}`, { workplaceId });
}

/**
 * POST /workplaces/{wid}/subscription with a Finix token. A declined card / missing
 * plan returns 402 → api() throws with .status/.body for the UI. WA billing
 * addresses are charged base + tax (rate re-resolved server-side from DOR).
 * @param {string} workplaceId
 * @param {{ token:string, cycle:'monthly'|'annual', email?:string, firstName?:string, lastName?:string,
 *           serviceLocation?:{ state:string, street?:string, city?:string, zip?:string } }} args
 */
export function createSubscription(workplaceId, args) {
  return api(`/workplaces/${workplaceId}/subscription`, { method: 'POST', workplaceId, body: args });
}

/** POST .../subscription/update-card — replace the card on the active subscription. */
export function updateCard(workplaceId, token) {
  return api(`/workplaces/${workplaceId}/subscription/update-card`, { method: 'POST', workplaceId, body: { token } });
}

/** POST .../subscription/auto-renew { enabled } → { autoRenew }. */
export function setAutoRenew(workplaceId, enabled) {
  return api(`/workplaces/${workplaceId}/subscription/auto-renew`, { method: 'POST', workplaceId, body: { enabled: !!enabled } });
}

/** POST .../subscription/cancel — access remains until currentPeriodEnd. */
export function cancelSubscription(workplaceId) {
  return api(`/workplaces/${workplaceId}/subscription/cancel`, { method: 'POST', workplaceId, body: {} });
}
